import { render } from "./Index.vue?vue&type=template&id=ab0373ce&scoped=true"
import script from "./Index.vue?vue&type=script&lang=ts"
export * from "./Index.vue?vue&type=script&lang=ts"

import "./Index.vue?vue&type=style&index=0&id=ab0373ce&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-ab0373ce"

export default script